import React, { useEffect, useState } from 'react';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import { SectionBase } from './SectionBase';
import { GuidanceTextResponse } from './utils';

const SHOW_ERROR_TIMEOUT = 5000;

interface SectionErrorBannerProps {
  sectionName: string;
  className?: string;
  guidanceText: GuidanceTextResponse;
}

const SectionErrorBanner: React.FC<SectionErrorBannerProps> = ({
  sectionName,
  className,
  guidanceText,
}) => {
  const [showError, setShowError] = useState<boolean>(false);
  useEffect(() => {
    const timeout = window.setTimeout(
      () => setShowError(true),
      SHOW_ERROR_TIMEOUT,
    );
    return () => {
      window.clearTimeout(timeout);
    };
  }, [setShowError]);
  if (sectionName === 'allocation') return null;
  return (
    <SectionBase
      title={sectionName}
      subTitle={undefined}
      helpText={undefined}
      questionId={undefined}
      guidanceText={guidanceText}
    >
      <div className={className}>
        {showError ? (
          <label>
            There are no questions loaded in <strong>{sectionName}</strong>{' '}
            section. Please continue...
          </label>
        ) : (
          <TrueImpactLoading />
        )}
      </div>
    </SectionBase>
  );
};

export default SectionErrorBanner;
